module.exports = __webpack_public_path__ + "img/TT.9314e47b.svg";